<template>
  <div>
    <!-- section start -->
    <section>
      <div class="inner row3_1 flex mobileFlexCol">
        <article class="wd100">
          <div class="matchingSection1">
            <h1 class="mainTitle">직접 매칭 관리</h1>

            <article class="aRow2">
              <h3 class="alignL statusMatchingTitle">
                매칭 현황
              </h3>
              <section class="flex  statusMatchingRow">
                <div
                  class="statusMatchingItem"
                  v-for="(item, index) in statusMatchingItems"
                  :key="index"
                >
                  <div class="boxText">
                    <h4 class="boxTextTitle">{{ item.title }}</h4>
                    <h2
                      class="boxTextNumber"
                      :style="{ color: item.textColor }"
                    >
                      {{ item.number }} 건
                    </h2>
                  </div>

                  <figure class="image">
                    <img :src="item.icon" :alt="item.title" />
                  </figure>

                  <div
                    class="lineBottom"
                    :style="{ backgroundColor: item.lineColor }"
                  ></div>
                </div>
              </section>
            </article>

            <article class="aRow2 directMatching">
              <h3 class="alignL statusMatchingTitle">
                직접매칭 목록 ({{ directMatchingHistoryList.length || "0" }})
              </h3>

              <div class="selectOption">
                <SelectOption
                  v-model="status"
                  :options="options"
                  width="200px"
                  :handleChangeOption="changeStatus"
                />
              </div>

              <section class="flex directMatchingList">
                <h5 v-if="directMatchingList.length == 0">
                  There is no data to show
                </h5>
                <ItemAdminDirectMatching
                  v-for="(item, index) in directMatchingList"
                  :key="index"
                  :item="item"
                  @openModal="handleOpenModal"
                />
              </section>
            </article>
            <PaginationMatching
              :rows="directMatchingHistoryList.length"
              :page.sync="page"
              :perPage="itemPerPage"
              @changePage="handleChangePage"
            />
          </div>
        </article>
      </div>
    </section>

    <MatchingPMReadPopup
      :isShowModalMatchingRead="isShowModalMatchingRead"
      @close-modal="handleCloseModal"
      :itemSelected="selectedMatching"
    />
  </div>
</template>
<script>
import SelectOption from "@/components/formControl/SelectOption.vue";
import PaginationMatching from "@/components/general/PaginationMatching.vue";
import ItemAdminDirectMatching from "@/components/items/ItemAdminDirectMatching.vue";
import MatchingPMReadPopup from "@/components/matching/popup/MatchingPMReadPopup.vue";
import { mapActions, mapState } from "vuex";
import matchingColorMixins from "@/mixins/matching-color-mixins";
import { matchingStatusOptions, directStatus } from "@/data/constances";

export default {
  name: "DirectorMatchingManagement",
  mixins: [matchingColorMixins],
  data() {
    return {
      isShowModalMatchingRead: false,
      options: matchingStatusOptions,
      page: 1,
      status: "",
      itemPerPage: 6,
      selectedMatching: {},
      statusMatchingItems: [
        {
          id: 1,
          title: "총 신청 수",
          number: "0",
          icon: "/images/manager/matching/docs.svg",
          lineColor: "#8D98C8",
          textColor: "#26336A",
        },
        {
          id: 1,
          title: "매칭 대기",
          number: "0",
          icon: "/images/manager/matching/community.svg",
          lineColor: "#B1DF8D",
          textColor: "#3F7416",
        },
        {
          id: 1,
          title: "매칭 완료",
          number: "0",
          icon: "/images/manager/matching/partner.svg",
          textColor: "#2B939A",
          lineColor: "#70CED4",
        },
        {
          id: 1,
          title: "매칭 거절",
          number: "0",
          icon: "/images/manager/matching/helper.svg",
          textColor: "#BD4444",
          lineColor: "#FF7878",
        },
      ],
    };
  },
  computed: {
    ...mapState("directMatchingHistory", [
      "directMatchingHistoryList",
      "statistic",
    ]),
    directMatchingList() {
      return this.directMatchingHistoryList
        .filter((item) => {
          if (this.status == "") return true;
          else return item.status == this.status;
        })
        .slice(
          (this.page - 1) * this.itemPerPage,
          this.page * this.itemPerPage
        );
    },
  },
  components: {
    SelectOption,
    MatchingPMReadPopup,
    ItemAdminDirectMatching,
    PaginationMatching,
  },

  watch: {
    statistic: {
      handler(val) {
        this.statusMatchingItems[0].number = val.all;
        this.statusMatchingItems[1].number = val.pending;
        this.statusMatchingItems[2].number = val.approve;
        this.statusMatchingItems[3].number = val.reject;
      },
      deep: true,
    },
    directMatchingHistoryList(val) {
      this.statusMatchingItems[0].number = val.length;
      this.statusMatchingItems[1].number = this.lodash.filter(val, function(o) {
        return o.status == directStatus.PENDING;
      }).length;
      this.statusMatchingItems[2].number = this.lodash.filter(val, function(o) {
        return o.status == directStatus.APPROVED;
      }).length;
      this.statusMatchingItems[3].number = this.lodash.filter(val, function(o) {
        return o.status == directStatus.REJECT;
      }).length;
    },
  },

  created() {
    this.loadDirectList();
    // this.getDirectMatchingStatistic();
  },

  methods: {
    ...mapActions("directMatching", ["getDirectMatchingDetail"]),
    ...mapActions("directMatchingHistory", [
      "loadDirectMatchingHistoryByStatus",
      "getDirectMatchingHistoryDetail",
      "getDirectMatchingStatistic",
    ]),
    changeStatus() {
      this.page = 1;
    },
    loadDirectList(status) {
      this.page = 1;
      this.loadDirectMatchingHistoryByStatus({ status });
    },
    handleChangePage(page) {
      this.page = page;
    },
    async handleOpenModal(item) {
      this.selectedMatching = item;
      this.isShowModalMatchingRead = true;
    },
    handleCloseModal() {
      this.isShowModalMatchingRead = false;
    },
  },
};
</script>

<style scoped lang="scss">
.matchingSection1 {
  .matchingSection1Title {
    color: #9e1915;
    text-align: center;
  }

  .statusMatchingTitle {
    color: #26336a;
  }

  .statusMatchingItem {
    width: 240px !important;
    height: 302px !important;
    background: #ffffff !important;
    border: 1px solid #ededed;
    border-radius: 10px;
    position: relative;
    overflow: hidden;

    .boxText {
      text-align: center;
      padding-top: 37px;

      .boxTextTitle {
        color: #6c6c6c;
      }

      .boxTextNumber {
        color: #26336a;
      }
    }

    .image {
      padding-top: 30px;
      height: 90px;
    }

    .lineBottom {
      position: absolute;
      height: 16px;
      width: 100%;
      background-color: #8d98c8;
      bottom: 0;
    }
  }

  .mainTitle {
    &::after {
      display: none !important;
    }
  }
}

.directMatching {
  .selectOption {
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid #d6d6d6;
    margin-bottom: 24px;
    padding-bottom: 12px;
  }

  .directMatchingList {
    display: grid;
    grid-template-columns: 50% 50%;
    gap: 24px;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 24px;
  }
}

@media screen and (max-width: 600px) {
  .directMatchingList {
    grid-template-columns: auto !important;
  }
}
</style>
